import Result from '@/modules/core/models/result.class'
import type { FeatureCollection } from 'geojson'

export default class ConstituencyShapeService {
    async getConstituencyShape(constituencyName: string) {
        try {
            // Normalize constituency name for file lookup
            const normalizedName = constituencyName.toLowerCase().replace(/\s+/g, '_')

            // Try to load the constituency-specific shape file
            const response = await fetch(`/src/assets/geojson/${normalizedName}_dummy.geojson`)

            if (!response.ok) {
                const error = new Error(`Shape file not found for constituency: ${constituencyName}`)
                return Result.failure(error)
            }

            const geoJson = await response.json() as FeatureCollection
            return Result.success(geoJson)
        } catch (e) {
            const error = e instanceof Error ? e : new Error('Failed to load constituency shape file')
            return Result.failure(error)
        }
    }

    async getConstituencyShapeByCode(constituencyCode: string) {
        try {
            // Try to load the constituency-specific shape file by code
            const response = await fetch(`/src/assets/geojson/${constituencyCode.toLowerCase()}_dummy.geojson`)

            if (!response.ok) {
                const error = new Error(`Shape file not found for constituency code: ${constituencyCode}`)
                return Result.failure(error)
            }

            const geoJson = await response.json() as FeatureCollection
            return Result.success(geoJson)
        } catch (e) {
            const error = e instanceof Error ? e : new Error('Failed to load constituency shape file')
            return Result.failure(error)
        }
    }
} 